import React, { PropTypes } from 'react';
import { WindowProxy, LocaleService } from '@sm360/widget-commons-core-services';
import { ErrorsHandler, ValidationService, Translations as FormsTranslations } from '@sm360/widget-commons-forms';
import { Quote } from '@sm360/widget-commons-vehicle';
import { Account, AnalyticsService } from '@sm360/widget-commons-general';
import { uniqBy } from 'lodash';

import DepositForm from 'deposit/components/DepositForm/DepositForm.jsx';

import StripeAPIService from 'deposit/services/StripeAPIService/StripeAPIService.js';
import DepositAPIService from 'deposit/services/DepositAPIService/DepositAPIService.js';

import ERRORS from 'deposit/constants/errors.js';

import en from 'deposit/i18n/en.json';
import fr from 'deposit/i18n/fr.json';

class Deposit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shownErrors: [],
            hasBeenSubmit: false,
        };

        LocaleService.loadTranslations({ en, fr });
        LocaleService.loadTranslations(FormsTranslations);

        this.createStripeToken = this.createStripeToken.bind(this);
        this.stripeResponseHandler = this.stripeResponseHandler.bind(this);
    }

    componentWillMount() {
        const windowProxy = WindowProxy.get();

        if (windowProxy) {
            const script = windowProxy.document.createElement('script');

            const promise = new Promise((resolve, reject) => {
                script.async = true;
                script.src = 'https://js.stripe.com/v2/';
                script.addEventListener('load', resolve);
                script.addEventListener('error', () => reject('Error loading script.'));
                script.addEventListener('abort', () => reject('Script loading aborted.'));
                windowProxy.document.head.appendChild(script);
            });

            promise.then(() => {
                WindowProxy.get().Stripe.setPublishableKey(this.props.stripePublishableKey);
            });
        }
    }

    createStripeToken(formState) {
        this.setState({
            hasBeenSubmit: true,
            shownErrors: formState.errors,
        });

        if (!ValidationService.validateForm(formState.formValidation)) {
            return;
        }

        this.setState(
            {
                account: formState.contact,
            },
            () => {
                this.props.lockScreen();
                StripeAPIService.createToken(formState.cardInfo, formState.contact, this.stripeResponseHandler);
            }
        );
    }

    handleStripeError(error) {
        const errors = [...this.state.shownErrors];
        const errorMessage = ERRORS[error.code] || ERRORS['error.default'];
        errors.push({
            message: LocaleService.t(errorMessage),
            code: error.code,
            group: 'depositGroup',
        });

        this.setState({
            shownErrors: uniqBy(errors, 'code'),
        });

        this.props.lockScreen();
    }

    stripeResponseHandler(status, stripeResponse) {
        this.setState({
            shownErrors: [],
        });
        if (stripeResponse.error) {
            this.handleStripeError(stripeResponse.error);
            return;
        }

        if (this.props.quote.vehicle.getIsVehicleNew()) {
            AnalyticsService.eventDataLayer('form|deposit-new', 'submit', 'deposit-showroom');
        } else {
            AnalyticsService.eventDataLayer('form|deposit-used', 'submit', 'deposit-showroom');
        }

        DepositAPIService.createDeposit(this.props.quote, stripeResponse.id, this.state.account)
            .then((showroomQuote) => {
                this.props.onSuccess(showroomQuote, this.state.account);
                this.props.lockScreen();
            })
            .catch(() => {
                this.setState({
                    shownErrors: [
                        {
                            message: LocaleService.t(ERRORS['error.payment']),
                            code: 'error.payment',
                            group: 'depositAPI',
                        },
                    ],
                });
                this.props.lockScreen();
            });
    }

    render() {
        const errorBlock = !!this.state.shownErrors.length && <ErrorsHandler errors={this.state.shownErrors} />;

        return (
            <div className="clearfix">
                {errorBlock}

                <DepositForm
                    account={this.props.account}
                    buttonConf={this.props.buttonConf}
                    onClick={this.createStripeToken}
                    depositAmount={this.props.depositAmount}
                    hasError={!!this.state.shownErrors.length}
                    errorMessage={this.state.shownErrors}
                    hasBeenSubmit={this.state.hasBeenSubmit}
                />
            </div>
        );
    }
}

Deposit.defaultProps = {
    account: new Account(),
    buttonConf: {
        label: LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.BUTTON_TITLE'),
        icon: null,
    },
    quote: new Quote.QuoteModel(),
    lockScreen: () => {},
    depositAmount: 500,
};

Deposit.propTypes = {
    account: PropTypes.instanceOf(Account),
    onSuccess: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    stripePublishableKey: PropTypes.string.isRequired,
    buttonConf: PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
    }),
    lockScreen: PropTypes.func,
    depositAmount: PropTypes.number,
};

Deposit.displayName = 'Deposit';

export default Deposit;



// WEBPACK FOOTER //
// ./src/components/Deposit/Deposit.jsx